import { inject, Injectable } from '@angular/core';
import { LocalStorageService } from '@core/services/local-storage.service';
import { LocalStorageKeys } from '@core/enums/local-storage-keys.enum';
import { isSupportedUiLang, SupportedUiLang } from '@core/types/language.types';

@Injectable({
  providedIn: 'root',
})
export class LanguageStorageService {
  private readonly localStorageService = inject(LocalStorageService);

  getFallbackUiLang(): SupportedUiLang {
    return 'pt-br';
  }

  uiLangToHeader(uiLang: string): string {
    switch (uiLang) {
      case 'pt-br':
        return 'pt-BR';
      case 'en':
        return 'en-US';
      case 'es':
        return 'es-ES';
      default:
        return 'pt-BR';
    }
  }

  get(): SupportedUiLang {
    const stored = this.localStorageService.getItem<string>(LocalStorageKeys.LANG);

    return isSupportedUiLang(stored) ? stored : this.getFallbackUiLang();
  }

  set(lang: SupportedUiLang): void {
    this.localStorageService.setItem(LocalStorageKeys.LANG, lang);
  }

  setSafe(lang: string): void {
    const chosen = isSupportedUiLang(lang) ? lang : this.getFallbackUiLang();
    this.set(chosen);
  }

  clear(): void {
    this.localStorageService.removeItem(LocalStorageKeys.LANG);
  }
}
